import React, { Fragment, useState, useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { Row, Col, Card, Button, Form, Alert } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import api from "../../../api";
import FilePreview from "../Common/FilePreview";
import swal from "sweetalert";
import Select from "react-select";

const DeliveryEdit = () => {
 const { id } = useParams();
 const navigate = useNavigate();
 const [searchParams] = useSearchParams();

 const projectFromUrl = searchParams.get("project");
 const workOrderFromUrl = searchParams.get("workOrder");
 const [loading, setLoading] = useState(false);
 const [fetching, setFetching] = useState(true);
 const [projects, setProjects] = useState([]);
 const [purchaseOrders, setPurchaseOrders] = useState([]);
 const [vendors, setVendors] = useState([]);
 const [workOrders, setWorkOrders] = useState([]);
 const [error, setError] = useState("");

 const [form, setForm] = useState({
 deliveryNumber: "",
 purchaseOrder: [],
 workOrder: "",

 project: "",
 vendor: "",
 challanDocument: null,
 items: [
 {
 itemName: "",
 quantityOrdered: "",
 quantityDelivered: "",
 unit: "",
 remark: "",
 },
 ],
 deliveryDate: new Date().toISOString().split("T")[0],
 clientStamp: null,
 testCertificate: null,
 signature: null,
 status: "Pending",
 remarks: "",
  manualShipTo: { phone: "" },
 driverName: "",
 driverPhone: "",
 vehicleNumber: "",
 transporterName: "",
 });

 const [units, setUnits] = useState([]);
 const statuses = ["Pending", "Inspected"];

 // ================================
 // INIT LOAD
 // ================================
 useEffect(() => {
 loadInitialData();
 }, [id]);

 const loadInitialData = async () => {
 try {
 setFetching(true);

 await fetchProjects();
 await fetchWorkOrders(); // 1 load dropdown options FIRST
 await fetchPurchaseOrders(); // 2
 await fetchVendors(); // 3
 await fetchUnits();
 await fetchDelivery(); // 4 SET FORM LAST
 } catch (err) {
 console.error(err);
 swal("Error", "Failed to load data", "error");
 } finally {
 setFetching(false);
 }
 };

 // ================================
 // FETCH DELIVERY TO EDIT
 // ================================
 const fetchDelivery = async () => {
 try {
 const res = await api.get(`/deliveries/${id}`);

 if (res.data.success) {
  const d = res.data.data;

  const workOrderId = d.workOrder?._id?.toString() || "";
  const pos = Array.isArray(d.purchaseOrder)
    ? d.purchaseOrder
    : d.purchaseOrder
    ? [d.purchaseOrder]
    : [];
  const purchaseOrderIds = pos.map((p) => (p && typeof p === "object" ? p._id?.toString() : p?.toString())).filter(Boolean);
  const vendorId = d.vendor?._id?.toString() || "";

  const projectId =
  d.project?._id || d.project || d.workOrder?.project?._id || "";

  // -----------------------------
  // [OK] SET FORM DATA
  // -----------------------------
  setForm({
  deliveryNumber: d.deliveryNumber || "",

  workOrder: workOrderId,
  purchaseOrder: purchaseOrderIds,
  project: projectId,
  vendor: vendorId,

 challanDocument: d.challanDocument || null,

 items:
 Array.isArray(d.items) && d.items.length
 ? d.items.map((i) => ({
 itemName: i.itemName || "",
 quantityOrdered: i.quantityOrdered ?? i.quantity ?? 0,
 quantityDelivered: i.quantityDelivered ?? "",
 unit: i.unit || "",
 remark: i.remark || "",
 isNonBillable: i.isNonBillable || false,
                                                                            subItems: (i.subItems || []).map((s) => ({
                                                                                name: s.name || "",
                                                                                quantityOrdered: s.quantityOrdered !== undefined ? s.quantityOrdered : (s.quantity ?? 0),
                                                                                quantity: s.quantity ?? 0,
                                                                                quantityDelivered: s.quantityDelivered !== undefined && s.quantityDelivered !== null ? s.quantityDelivered : (s.quantity ?? ""),
                                                                                unit: s.unit || i.unit || "",
                                                                                remarks: s.remarks || "",
                                                                            })),
 purchaseOrder: i.purchaseOrder || "",
 poNumber: i.poNumber || "",
 }))
 : [
 {
 itemName: "",
 quantityOrdered: "",
 quantityDelivered: "",
 unit: "",
 remark: "",
 isNonBillable: false,
 purchaseOrder: "",
 poNumber: "",
 },
 ],

 deliveryDate: d.deliveryDate ? d.deliveryDate.split("T")[0] : "",

 clientStamp: d.clientStamp || null,
 testCertificate: d.testCertificate || null,
 signature: d.signature || null,

 status: d.status || "Pending",
 remarks: d.remarks || "",
  manualShipTo: d.manualShipTo || { phone: "" },

 driverName: d.dispatchDetails?.driverName || "",
 driverPhone: d.dispatchDetails?.driverPhone || "",
 vehicleNumber: d.dispatchDetails?.vehicleNumber || "",
 transporterName: d.dispatchDetails?.transporterName || "",
 });

        // -------------------------------------------------
        // [OK] Ensure project exists in dropdown
        // -------------------------------------------------
        if (d.project && typeof d.project === "object") {
          setProjects((prev) => {
            const exists = prev.some((p) => p._id === d.project._id);
            if (exists) return prev;
            return [d.project, ...prev];
          });
        }

 // -------------------------------------------------
 // [OK] CRITICAL FIX: Ensure workOrder exists in dropdown
 // -------------------------------------------------
 if (d.workOrder) {
 setWorkOrders((prev) => {
 const exists = prev.some((wo) => wo._id === d.workOrder._id);

 if (exists) return prev;

 return [
 {
 _id: d.workOrder._id,
 woNumber: d.workOrder.woNumber || d.workOrder.woNo || "WO",
 scope: d.workOrder.scope || "",
 project: d.workOrder.project,
 },
 ...prev,
 ];
 });
 }

 // -------------------------------------------------
 // [OK] Ensure purchase order exists (edit safety)
 // -------------------------------------------------
  if (d.purchaseOrder) {
    const pos = Array.isArray(d.purchaseOrder) ? d.purchaseOrder : [d.purchaseOrder];
    setPurchaseOrders((prev) => {
      let updated = [...prev];
      pos.forEach((p) => {
        if (p && typeof p === "object" && p._id && !updated.some((x) => String(x._id) === String(p._id))) {
          updated.push(p);
        }
      });
      return updated;
    });
  }
 }
 } catch (err) {
 console.error(err);
 swal("Error", "Failed to load delivery", "error");
 navigate("/delivery");
 }
 };

 const fetchProjects = async () => {
 try {
 const res = await api.get("/projects?limit=1000");
 if (res.data.success) setProjects(res.data.data || []);
 } catch (err) {
 console.error(err);
 }
 };

 const fetchPurchaseOrders = async () => {
 try {
 const res = await api.get("/purchase-orders?limit=1000");
 if (res.data.success) setPurchaseOrders(res.data.data);
 } catch (err) {
 console.error(err);
 }
 };

 const fetchVendors = async () => {
 try {
 const res = await api.get("/vendors?limit=1000");
 if (res.data.success) setVendors(res.data.data);
 } catch (err) {
 console.error(err);
 }
 };

 const fetchWorkOrders = async () => {
 try {
 const res = await api.get("/work-orders?limit=1000");
 if (res.data.success) setWorkOrders(res.data.data);
 } catch (err) {
 console.error(err);
 }
 };

 const fetchUnits = async () => {
 try {
 const res = await api.get("/boq-unit-types");

 if (res.data.success) {
 setUnits(res.data.data);
 }
 } catch (err) {
 console.error("Failed to fetch units", err);
 swal("Error", "Failed to fetch unit master", "error");
 }
 };

  const filteredWorkOrders = form.project
    ? workOrders.filter((wo) => {
        const pId = wo.project?._id || wo.project;
        return String(pId) === String(form.project) || (form.workOrder && String(wo._id) === String(form.workOrder));
      })
    : workOrders;

  const filteredPurchaseOrders = purchaseOrders.filter((po) => {
    const isSelected = (Array.isArray(form.purchaseOrder) ? form.purchaseOrder : [form.purchaseOrder]).some(
      (id) => String(id?._id || id) === String(po._id)
    );
    if (isSelected) return true;

    if (!form.workOrder) return false;
    const woId = po.workOrder?._id || po.workOrder;
    return String(woId) === String(form.workOrder);
  });

 // ================================
 // MULTI PO HANDLER
 // ================================
 const handlePurchaseOrderChange = (selectedOptions) => {
 const selectedPoIds = (selectedOptions || []).map((opt) => opt.value);

 if (!selectedPoIds.length) {
 setForm((prev) => ({
 ...prev,
 purchaseOrder: [],
 items: [
 {
 itemName: "",
 quantityOrdered: "",
 quantityDelivered: "",
 unit: "",
 remark: "",
 isNonBillable: false,
 purchaseOrder: "",
 poNumber: "",
 },
 ],
 }));
 return;
 }

  const selectedPOs = purchaseOrders.filter((po) =>
    selectedPoIds.map(String).includes(String(po._id))
  );

  const firstPO = selectedPOs[0];
  const vendorId = firstPO?.vendor?._id || firstPO?.vendor || "";

  // Keep items from currently selected POs (or keep items without PO so legacy items aren't dropped)
  const existingValidItems = form.items.filter((item) =>
    !item.purchaseOrder || selectedPoIds.map(String).includes(String(item.purchaseOrder))
  );

  const currentSelectedPoIds = (
    Array.isArray(form.purchaseOrder)
      ? form.purchaseOrder
      : form.purchaseOrder
      ? [form.purchaseOrder]
      : []
  ).map((p) => String(p?._id || p));

  const newlyAddedPoIds = selectedPoIds.filter(
    (id) => !currentSelectedPoIds.includes(String(id))
  );

 const newItems = [];
 newlyAddedPoIds.forEach((poId) => {
 const po = purchaseOrders.find((p) => p._id === poId);
 if (po && Array.isArray(po.items)) {
 po.items.forEach((i) => {
 newItems.push({
 itemName: i.itemName || "",
 quantityOrdered: i.quantity || 0,
 quantityDelivered: "",
 unit: i.unit || "",
 remark: "",
 isNonBillable: i.isNonBillable || false,
 purchaseOrder: po._id,
 poNumber: po.poNumber || "",
 });
 });
 }
 });

 const combined = [...existingValidItems, ...newItems].filter(
 (item) => item.itemName || item.purchaseOrder
 );

 setForm((prev) => ({
 ...prev,
 purchaseOrder: selectedPoIds,
 vendor: vendorId || prev.vendor,
 items: combined.length > 0 ? combined : [
 {
 itemName: "",
 quantityOrdered: "",
 quantityDelivered: "",
 unit: "",
 remark: "",
 isNonBillable: false,
 purchaseOrder: "",
 poNumber: "",
 },
 ],
 }));
 };

 // ================================
 // HANDLERS
 // ================================
 const handleChange = (e) => {
 const { name, value } = e.target;

 if (name === "project") {
 setForm((prev) => ({
 ...prev,
 project: value,
 workOrder: "",
 purchaseOrder: [],
 vendor: "",
 items: [
 {
 itemName: "",
 quantityOrdered: "",
 quantityDelivered: "",
 unit: "",
 remark: "",
 purchaseOrder: "",
 poNumber: "",
 },
 ],
 }));
 return;
 }

 if (name === "workOrder") {
 const selectedWO = workOrders.find((w) => w._id === value);
 const projectId = selectedWO ? (selectedWO.project?._id || selectedWO.project) : form.project;

 setForm((prev) => ({
 ...prev,
 workOrder: value,
 project: projectId || prev.project,
 purchaseOrder: [],
 vendor: "",
 items: [
 {
 itemName: "",
 quantityOrdered: "",
 quantityDelivered: "",
 unit: "",
 remark: "",
 purchaseOrder: "",
 poNumber: "",
 },
 ],
 }));
 return;
 }

 if (name === "driverPhone") {
 const sanitized = value.replace(/[^\d+ _-]/g, ""); // Allow digits, +, space, _, -
 if (sanitized.length <= 16) {
 setForm((prev) => ({ ...prev, [name]: sanitized }));
 }
 return;
 }

 setForm((prev) => ({ ...prev, [name]: value }));
 };

 // ================================
 // ITEM CHANGE
 // ================================
 const handleItemChange = (index, field, value) => {
 const updated = [...form.items];

 // Prevent delivered > ordered
 if (field === "quantityDelivered") {
 const ordered = Number(updated[index].quantityOrdered || 0);
 const delivered = Number(value);

 if (delivered > ordered) {
 swal("Warning", "Delivered quantity cannot exceed ordered!", "warning");
 return;
 }
 }

  updated[index][field] = value;
  setForm((prev) => ({ ...prev, items: updated }));
  };

  const handleSubItemChange = (itemIndex, subIndex, field, value) => {
    const updatedItems = [...form.items];
    const currentItem = { ...updatedItems[itemIndex] };
    const subItems = [...(currentItem.subItems || [])];
    let finalValue = value;

    if (field === "quantityDelivered" && finalValue !== "") {
      const numVal = parseFloat(finalValue);
      const maxVal = parseFloat(subItems[subIndex]?.quantityOrdered ?? subItems[subIndex]?.quantity);
      if (!isNaN(numVal) && !isNaN(maxVal) && numVal > maxVal) {
        finalValue = maxVal;
      }
    }

    const updatedSub = {
      ...subItems[subIndex],
      [field]: finalValue,
    };

    subItems[subIndex] = updatedSub;
    currentItem.subItems = subItems;

    // Pro-rata parent quantityDelivered from sub-items
    const totalSubPoQty = subItems.reduce(
      (sum, s) => sum + (parseFloat(s.quantityOrdered ?? s.quantity) || 0),
      0
    );
    const currentTotalDelivered = subItems.reduce(
      (sum, s) => sum + (parseFloat(s.quantityDelivered) || 0),
      0
    );
    const parentOrderedQty = parseFloat(currentItem.quantityOrdered) || 0;

    if (parentOrderedQty > 0 && totalSubPoQty > 0) {
      const newParentDelivered = currentTotalDelivered === 0
        ? 0
        : parseFloat(((currentTotalDelivered / totalSubPoQty) * parentOrderedQty).toFixed(4));
      currentItem.quantityDelivered = newParentDelivered;
    }

    updatedItems[itemIndex] = currentItem;
    setForm((prev) => ({ ...prev, items: updatedItems }));
  };

 const addItem = () => {
 setForm((prev) => ({
 ...prev,
 items: [
 ...prev.items,
 {
 itemName: "",
 quantityOrdered: "",
 quantityDelivered: "",
 unit: "",
 remark: "",
 },
 ],
 }));
 };

 const removeItem = (index) => {
 if (form.items.length === 1) {
 swal("Warning", "At least one item is required", "warning");
 return;
 }
 setForm((prev) => ({
 ...prev,
 items: prev.items.filter((_, i) => i !== index),
 }));
 };

 // ================================
 // FILE HANDLING
 // ================================
 const handleFile = (e, field) => {
 const file = e.target.files[0];

 if (!file) return;

 if (file.size > 5 * 1024 * 1024) {
 swal("Warning", "File size must be under 5MB", "warning");
 return;
 }

 setForm((prev) => ({
 ...prev,
 [field]: file,
 }));
 };

 const removeFile = (field) => {
 setForm((prev) => ({
 ...prev,
 [field]: null,
 }));
 };

 // ================================
 // SUBMIT
 // ================================
 const handleSubmit = async (e) => {
 e.preventDefault();

  const poList = Array.isArray(form.purchaseOrder)
    ? form.purchaseOrder
    : (form.purchaseOrder ? [form.purchaseOrder] : []);

  if (!poList.length)
    return swal("Warning", "Select at least one purchase order", "warning");
  if (!form.workOrder) return swal("Warning", "Select work order", "warning");

 if (!form.vendor) return swal("Warning", "Vendor not selected", "warning");

  if (form.items.some((i) => !i.itemName || i.quantityDelivered === "" || i.quantityDelivered === undefined || i.quantityDelivered === null)) {
    return swal("Warning", "Fill all item details", "warning");
  }

 try {
 setLoading(true);

 const upload = async (file) => {
 if (!file || !(file instanceof File)) return null;

 const fd = new FormData();
 fd.append("file", file);

 const res = await api.post("/deliveries/upload/single", fd, {
 headers: { "Content-Type": "multipart/form-data" },
 });

 return res.data.success
 ? {
 fileName: res.data.fileName,
 fileUrl: res.data.fileUrl,
 filePath: res.data.filePath,
 }
 : null;
 };

 const challanDoc = await upload(form.challanDocument);
 const clientStamp = await upload(form.clientStamp);
 const testCert = await upload(form.testCertificate);

    const sanitizedPoList = poList
      .map((p) => (p && typeof p === "object" ? p.value || p._id : p))
      .filter(Boolean);

    const sanitizedItems = form.items.map((item) => {
      const itemPo =
        item.purchaseOrder && typeof item.purchaseOrder === "object"
          ? item.purchaseOrder._id || item.purchaseOrder.value
          : item.purchaseOrder;

      const poToUse =
        itemPo || (sanitizedPoList.length === 1 ? sanitizedPoList[0] : null);

      return {
        ...item,
        purchaseOrder: poToUse || null,
        poNumber: item.poNumber || "",
        subItems: (item.subItems || []).map((s) => {
          const rawDel = s.quantityDelivered !== undefined && s.quantityDelivered !== null && s.quantityDelivered !== ""
            ? parseFloat(s.quantityDelivered)
            : (s.quantity !== undefined && s.quantity !== "" ? parseFloat(s.quantity) : 0);
          const delQty = isNaN(rawDel) ? 0 : rawDel;
          const ordQty = parseFloat(s.quantityOrdered !== undefined ? s.quantityOrdered : s.quantity) || 0;
          return {
            name: s.name || "",
            quantityOrdered: ordQty,
            quantity: delQty,
            quantityDelivered: delQty,
            unit: s.unit || item.unit || "",
            remarks: s.remarks || "",
          };
        }),
      };
    });

    const payload = {
      ...form,
      purchaseOrder: sanitizedPoList,
      items: sanitizedItems,
      challanDocument: challanDoc || (form.challanDocument instanceof File ? null : form.challanDocument),
      clientStamp: clientStamp || (form.clientStamp instanceof File ? null : form.clientStamp),
      testCertificate: testCert || (form.testCertificate instanceof File ? null : form.testCertificate),
    };

 const res = await api.patch(`/deliveries/${id}`, payload);

 if (res.data.success) {
 swal("Updated!", "Delivery updated successfully!", "success").then(() => {
 const filterQuery = [
 projectFromUrl ? `project=${projectFromUrl}` : "",
 workOrderFromUrl ? `workOrder=${workOrderFromUrl}` : "",
 ]
 .filter(Boolean)
 .join("&");

 navigate(filterQuery ? `/delivery?${filterQuery}` : "/delivery");
 });
 }
 } catch (err) {
 console.error(err);
 swal("Error", err.response?.data?.message || "Failed to update", "error");
 } finally {
 setLoading(false);
 }
 };

 // ================================
 // RENDER
 // ================================
 if (fetching) {
 return (
 <Fragment>
 <PageTitle activeMenu="Edit Delivery" motherMenu="Procurement" />
 <Row>
 <Col lg={12}>
 <Card>
 <Card.Body className="text-center py-5">
 <div className="spinner-border text-primary" role="status">
 <span className="visually-hidden">Loading...</span>
 </div>
 <p className="mt-3">Loading delivery details...</p>
 </Card.Body>
 </Card>
 </Col>
 </Row>
 </Fragment>
 );
 }

 return (
 <Fragment>
 <PageTitle activeMenu="Edit Delivery" motherMenu="Procurement" />

 {error && (
 <Alert
 variant="danger"
 dismissible
 onClose={() => setError("")}
 className="mb-3"
 >
 <i className="fas fa-exclamation-triangle me-2"></i>
 {error}
 </Alert>
 )}

 {(!purchaseOrders.length || !vendors.length || !workOrders.length) && (
 <Alert variant="warning" className="mb-3">
 <i className="fas fa-info-circle me-2"></i>
 Some required data is missing:
 {!purchaseOrders.length && <div>- No purchase orders found</div>}
 {!vendors.length && <div>- No vendors found</div>}
 {!workOrders.length && <div>- No work orders/projects found</div>}
 </Alert>
 )}

 <Row>
 <Col lg={12}>
 <Card>
 <Card.Header className="d-flex justify-content-between align-items-center">
 <Card.Title>Edit Delivery</Card.Title>
 <Button
 variant="secondary"
 onClick={() =>
 navigate(
 projectFromUrl || workOrderFromUrl
 ? `/delivery?${projectFromUrl ? `project=${projectFromUrl}&` : ""}${
 workOrderFromUrl
 ? `workOrder=${workOrderFromUrl}`
 : ""
 }`
 : "/delivery",
 )
 }
 >
 <i className="fas fa-arrow-left me-2"></i>Back
 </Button>
 </Card.Header>

 <Card.Body>
 <Form onSubmit={handleSubmit}>
 {/* Basic Details */}
 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Delivery Number <span className="text-danger">*</span>
 </Form.Label>
 <Form.Control
 type="text"
 name="deliveryNumber"
 value={form.deliveryNumber}
 readOnly
 disabled
 />
 <Form.Text className="text-muted">
 Auto-generated at creation (cannot be changed).
 </Form.Text>
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Project <span className="text-danger">*</span>
 </Form.Label>
 <Form.Select
 name="project"
 value={form.project}
 onChange={handleChange}
 required
 >
 <option value="">Select Project</option>
 {projects.map((p) => (
 <option key={p._id} value={p._id}>
 {p.projectName || p.name || p.projectCode}
 </option>
 ))}
 </Form.Select>
 <Form.Text className="text-muted">
 Work orders will be filtered by selected project
 </Form.Text>
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Work Order <span className="text-danger">*</span>
 </Form.Label>

 <Form.Select
 name="workOrder"
 value={form.workOrder}
 onChange={handleChange}
 required
 disabled={!form.project || !filteredWorkOrders.length}
 >
 <option value="">
 {!form.project
 ? "Select Project first"
 : filteredWorkOrders.length
 ? "Select Work Order"
 : "No work orders found for this project"}
 </option>
 {filteredWorkOrders.map((wo) => (
 <option key={wo._id} value={wo._id}>
 {wo.woNo || wo.woNumber}{wo.label ? ` – ${wo.label}` : ""}
 </option>
 ))}
 </Form.Select>

 <Form.Text className="text-muted">
 Purchase Orders will be filtered by selected work order
 </Form.Text>
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Purchase Order <span className="text-danger">*</span>
 </Form.Label>  <Select
    isMulti
    name="purchaseOrder"
    placeholder={
      !form.workOrder
        ? "Select Work Order first"
        : filteredPurchaseOrders.length
        ? "Select Purchase Order(s)..."
        : "No POs for selected work order"
    }
    isDisabled={!form.workOrder || !filteredPurchaseOrders.length}
    options={filteredPurchaseOrders.map((po) => ({
      value: po._id,
      label: `${po.poNumber} ${po.vendor?.name ? `- ${po.vendor.name}` : ""}`,
    }))}
    value={
      (Array.isArray(form.purchaseOrder) ? form.purchaseOrder : (form.purchaseOrder ? [form.purchaseOrder] : []))
        .map((id) => {
          const rawId = id && typeof id === "object" ? (id._id || id.value) : id;
          const po = purchaseOrders.find((p) => String(p._id) === String(rawId));
          if (po) {
            return {
              value: po._id,
              label: `${po.poNumber} ${po.vendor?.name ? `- ${po.vendor.name}` : ""}`,
            };
          }
          if (id && typeof id === "object" && (id.poNumber || id.label)) {
            return {
              value: id._id || id.value,
              label: id.label || `${id.poNumber} ${id.vendor?.name ? `- ${id.vendor.name}` : ""}`,
            };
          }
          return null;
        })
        .filter(Boolean)
    }
    onChange={handlePurchaseOrderChange}
    styles={{
      control: (base) => ({
        ...base,
        minHeight: "38px",
      }),
    }}
  />
  <Form.Text className="text-muted">
    Select one or more POs. Vendor & items will auto-populate.
  </Form.Text>
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Vendor <span className="text-danger">*</span>
 </Form.Label>
 <Form.Select
 name="vendor"
 value={form.vendor}
 onChange={handleChange}
 required
 disabled
 >
 <option value="">
 {vendors.length
 ? "Select Vendor"
 : "No vendors available"}
 </option>
 {vendors.map((vendor) => (
 <option key={vendor._id} value={vendor._id}>
 {vendor.name}
 </option>
 ))}
 </Form.Select>
 <Form.Text className="text-muted">
 Auto-selected from Purchase Order (locked here).
 </Form.Text>
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Ship To Phone / Contact Number</Form.Label>
 <Form.Control
 type="text"
 name="shipToPhone"
 value={form.manualShipTo?.phone || ""}
 onChange={(e) => setForm((prev) => ({
 ...prev,
 manualShipTo: { ...(prev.manualShipTo || {}), phone: e.target.value }
 }))}
 placeholder="Enter Ship To phone (optional)"
 />
 <Form.Text className="text-muted">
 Destination / Recipient site contact number
 </Form.Text>
 </Form.Group>
 </Col>
 </Row>

 {/* Date + Status */}
 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>
 Delivery Date <span className="text-danger">*</span>
 </Form.Label>
 <Form.Control
 type="date"
 name="deliveryDate"
 value={form.deliveryDate}
 onChange={handleChange}
 required
 />
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Status</Form.Label>
 <Form.Select
 name="status"
 value={form.status}
 onChange={handleChange}
 >
 {statuses.map((status, i) => (
 <option key={i} value={status}>
 {status}
 </option>
 ))}
 </Form.Select>
 </Form.Group>
 </Col>
 </Row>

 {/* ITEMS SECTION */}
 <div className="mt-4">
 <div className="d-flex justify-content-between align-items-center mb-3">
 <h5>Items ({form.items.length})</h5>
 <Button variant="success" size="sm" onClick={addItem}>
 <i className="fas fa-plus me-2"></i>Add Item
 </Button>
 </div>

 {form.items.map((item, index) => (
 <Card key={index} className="mb-3 border">
 <Card.Body>        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex align-items-center gap-2">
            <h6 className="mb-0">Item #{index + 1}</h6>
            {item.poNumber && (
              <span className="badge bg-light text-primary border" style={{ fontSize: "0.75rem" }}>
                <i className="fas fa-file-invoice me-1"></i>{item.poNumber}
              </span>
            )}
            {item.isNonBillable ? (
              <span className="badge bg-warning text-dark" style={{ fontSize: "0.7rem" }}>Non-Billable</span>
            ) : (
              <span className="badge bg-success" style={{ fontSize: "0.7rem" }}>Billable</span>
            )}
          </div>
          {form.items.length > 1 && (
            <Button
              variant="danger"
              size="sm"
              onClick={() => removeItem(index)}
            >
              <i className="fas fa-trash"></i>
            </Button>
          )}
        </div>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                Item Name <span className="text-danger">*</span>
              </Form.Label>
              <Select
                placeholder="Search & select item..."
                isClearable
                options={
                  (Array.isArray(form.purchaseOrder)
                    ? form.purchaseOrder
                    : form.purchaseOrder
                    ? [form.purchaseOrder]
                    : []
                  ).flatMap((pId) => {
                    const p = purchaseOrders.find((x) => x._id === pId);
                    if (!p || !Array.isArray(p.items)) return [];
                    return p.items.map((i) => ({
                      value: `${p._id}:::${i.itemName}`,
                      itemName: i.itemName,
                      quantity: i.quantity || 0,
                      unit: i.unit || "",
                      poId: p._id,
                      poNumber: p.poNumber || "",
                      isNonBillable: i.isNonBillable || false,
                      label: `${i.itemName} (${p.poNumber || "PO"}) — ${i.quantity} ${i.unit || ""}`,
                    }));
                  })
                }
                value={
                  item.itemName
                    ? {
                        value: item.purchaseOrder ? `${item.purchaseOrder}:::${item.itemName}` : item.itemName,
                        label: `${item.itemName}${item.poNumber ? ` (${item.poNumber})` : ""} — ${item.quantityOrdered || ""} ${item.unit || ""}`,
                      }
                    : null
                }
                onChange={(selected) => {
                  if (selected) {
                    handleItemChange(index, "itemName", selected.itemName);
                    handleItemChange(index, "quantityOrdered", selected.quantity);
                    handleItemChange(index, "unit", selected.unit || "");
                    handleItemChange(index, "purchaseOrder", selected.poId);
                    handleItemChange(index, "poNumber", selected.poNumber);
                    handleItemChange(index, "isNonBillable", selected.isNonBillable);
                                                                        const mappedSubs = (selected.subItems || []).map((s) => ({
                                                                            name: s.name || "",
                                                                            quantityOrdered: s.quantity || 0,
                                                                            quantity: s.quantity || 0,
                                                                            quantityDelivered: s.quantity !== undefined ? s.quantity : "",
                                                                            unit: s.unit || selected.unit || "",
                                                                            remarks: s.remarks || "",
                                                                        }));
                                                                        handleItemChange(index, "subItems", mappedSubs);
                  } else {
                    handleItemChange(index, "itemName", "");
                  }
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: "38px",
                  }),
                }}
              />
            </Form.Group>
          </Col>

 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Uom</Form.Label>
 <Form.Select
 value={item.unit || ""}
 onChange={(e) =>
 handleItemChange(
 index,
 "unit",
 e.target.value,
 )
 }
 >
 {/* Placeholder */}
 <option value="">Select Uom</option>

 {/* Show existing unit if not in master */}
 {item.unit &&
 !units.some((u) => u.name === item.unit) && (
 <option value={item.unit}>
 {item.unit}
 </option>
 )}

 {/* Unit Master */}
 {units.map((u) => (
 <option key={u._id} value={u.name}>
 {u.name}
 </option>
 ))}
 </Form.Select>
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={4}>
 <Form.Group className="mb-3">
 <Form.Label>Quantity Ordered</Form.Label>
 <Form.Control
 type="number"
 value={item.quantityOrdered}
 readOnly
 disabled
 />
 </Form.Group>
 </Col>

 <Col md={4}>
 <Form.Group className="mb-3">
 <Form.Label>
 Quantity Delivered{" "}
 <span className="text-danger">*</span>
 </Form.Label>
 <Form.Control
 type="number"
 step="0.01"
 min="0"
 value={item.quantityDelivered}
 onChange={(e) =>
 handleItemChange(
 index,
 "quantityDelivered",
 e.target.value,
 )
 }
 placeholder="Enter delivered quantity"
 required
 />
 </Form.Group>
 </Col>

 <Col md={4}>
 <Form.Group className="mb-3">
 <Form.Label>Item Remark</Form.Label>
 <Form.Control
 type="text"
 value={item.remark || ""}
 onChange={(e) =>
 handleItemChange(
 index,
 "remark",
 e.target.value,
 )
 }
 placeholder="Enter remark"
 />
 </Form.Group>
 </Col>
 </Row>
  {item.subItems && item.subItems.length > 0 && (
    <div className="mt-2 p-2 bg-light rounded border">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <small className="text-primary fw-bold">
          <i className="fa fa-list-ul me-1"></i> Sub-Items Breakdown (Enter delivered quantity for sub-items):
        </small>
      </div>
      <div className="table-responsive">
        <table className="table table-sm table-bordered bg-white mb-0" style={{ fontSize: "0.82rem" }}>
          <thead className="table-light">
            <tr>
              <th style={{ width: "35%" }}>Sub-Item Name</th>
              <th style={{ width: "15%" }} className="text-center">PO Quantity</th>
              <th style={{ width: "20%" }} className="text-center">Delivered Qty <span className="text-danger">*</span></th>
              <th style={{ width: "15%" }} className="text-center">UOM</th>
              <th style={{ width: "15%" }}>Remarks</th>
            </tr>
          </thead>
          <tbody>
            {item.subItems.map((sub, sIdx) => {
              const maxQty = sub.quantityOrdered !== undefined ? sub.quantityOrdered : sub.quantity;
              const delVal = sub.quantityDelivered !== undefined && sub.quantityDelivered !== null
                ? sub.quantityDelivered
                : (sub.quantity !== undefined && sub.quantity !== null ? sub.quantity : "");
              return (
                <tr key={sIdx}>
                  <td className="align-middle"><strong>{sub.name}</strong></td>
                  <td className="align-middle text-center font-w600 text-muted">{maxQty}</td>
                  <td className="align-middle">
                    <Form.Control
                      type="number"
                      step="0.01"
                      min="0"
                      max={maxQty !== undefined ? maxQty : undefined}
                      size="sm"
                      placeholder="0.00"
                      value={delVal}
                      onChange={(e) => handleSubItemChange(index, sIdx, "quantityDelivered", e.target.value)}
                      style={{ fontSize: "0.82rem" }}
                      required
                    />
                  </td>
                  <td className="align-middle">
                    <Form.Select
                      size="sm"
                      value={sub.unit || item.unit || ""}
                      onChange={(e) => handleSubItemChange(index, sIdx, "unit", e.target.value)}
                      style={{ fontSize: "0.82rem" }}
                    >
                      <option value="">Select UOM</option>
                      {(sub.unit || item.unit) &&
                        !units.some((u) => u.name === (sub.unit || item.unit)) && (
                          <option value={sub.unit || item.unit}>
                            {sub.unit || item.unit}
                          </option>
                        )}
                      {units.map((u) => (
                        <option key={u._id} value={u.name}>
                          {u.name}
                        </option>
                      ))}
                    </Form.Select>
                  </td>
                  <td className="align-middle">
                    <Form.Control
                      type="text"
                      size="sm"
                      placeholder="Remark"
                      value={sub.remarks || ""}
                      onChange={(e) => handleSubItemChange(index, sIdx, "remarks", e.target.value)}
                      style={{ fontSize: "0.82rem" }}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  )}
</Card.Body>
 </Card>
 ))}
 </div>

 {/* DOCUMENTS SECTION */}
 <div className="mt-4">
 <h5 className="mb-3">Documents</h5>
 <Row>
 {/* Challan */}
 <Col md={4}>
 <Form.Group className="mb-3">
 <Form.Label>Upload Challan Document</Form.Label>
 <Form.Control
 type="file"
 accept=".pdf,.jpg,.jpeg,.png"
 onChange={(e) => handleFile(e, "challanDocument")}
 />
 <FilePreview
 file={form.challanDocument}
 onRemove={() => removeFile("challanDocument")}
 />
 </Form.Group>
 </Col>

 {/* Other Related Document */}
 <Col md={4}>
 <Form.Group className="mb-3">
 <Form.Label>Upload other related doc</Form.Label>
 <Form.Control
 type="file"
 accept=".pdf,.jpg,.jpeg,.png"
 onChange={(e) => handleFile(e, "clientStamp")}
 />
 <FilePreview
 file={form.clientStamp}
 onRemove={() => removeFile("clientStamp")}
 />
 </Form.Group>
 </Col>

 {/* Test Certificate */}
 <Col md={4}>
 <Form.Group className="mb-3">
 <Form.Label>Upload Test Certificate</Form.Label>
 <Form.Control
 type="file"
 accept=".pdf,.jpg,.jpeg,.png"
 onChange={(e) => handleFile(e, "testCertificate")}
 />
 <FilePreview
 file={form.testCertificate}
 onRemove={() => removeFile("testCertificate")}
 />
 </Form.Group>
 </Col>
 </Row>
 </div>

 {/* REMARKS */}
 <Form.Group className="mb-3">
 <Form.Label>Remarks</Form.Label>
 <Form.Control
 as="textarea"
 rows={3}
 name="remarks"
 value={form.remarks}
 onChange={handleChange}
 placeholder="Enter any additional remarks..."
 />
 </Form.Group>

 {/* DRIVER / DISPATCH */}
 <div className="mt-4">
 <h5 className="mb-3">Dispatch / Driver Details</h5>
 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Driver Name</Form.Label>
 <Form.Control
 type="text"
 name="driverName"
 value={form.driverName}
 onChange={handleChange}
 placeholder="Enter driver name"
 />
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Driver Phone</Form.Label>
 <Form.Control
 type="text"
 name="driverPhone"
 value={form.driverPhone}
 onChange={handleChange}
 placeholder="Enter driver contact number"
 maxLength={16}
 />
 </Form.Group>
 </Col>
 </Row>

 <Row>
 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Vehicle Number</Form.Label>
 <Form.Control
 type="text"
 name="vehicleNumber"
 value={form.vehicleNumber}
 onChange={handleChange}
 placeholder="e.g. RJ14 XX 1234"
 />
 </Form.Group>
 </Col>

 <Col md={6}>
 <Form.Group className="mb-3">
 <Form.Label>Transporter / Agency</Form.Label>
 <Form.Control
 type="text"
 name="transporterName"
 value={form.transporterName}
 onChange={handleChange}
 placeholder="Enter transporter / agency name"
 />
 </Form.Group>
 </Col>
 </Row>
 </div>

 {/* BUTTONS */}
 <div className="d-flex gap-2 mt-4">
 <Button type="submit" variant="primary" disabled={loading}>
 {loading ? (
 <>
 <span className="spinner-border spinner-border-sm me-2"></span>
 Updating...
 </>
 ) : (
 <>
 <i className="fas fa-save me-2"></i>Update Delivery
 </>
 )}
 </Button>

 <Button
 type="button"
 variant="danger"
 onClick={() =>
 navigate(
 projectFromUrl || workOrderFromUrl
 ? `/delivery?${projectFromUrl ? `project=${projectFromUrl}&` : ""}${
 workOrderFromUrl
 ? `workOrder=${workOrderFromUrl}`
 : ""
 }`
 : "/delivery",
 )
 }
 disabled={loading}
 >
 <i className="fas fa-times me-2"></i>Cancel
 </Button>
 </div>
 </Form>
 </Card.Body>
 </Card>
 </Col>
 </Row>
 </Fragment>
 );
};

export default DeliveryEdit;
